import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../components/ui/card";
import { ShieldCheck, Loader2 } from "lucide-react";
import { API } from "../App";

const TwoFactorVerifyPage = ({ setUser }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const tempToken = searchParams.get("temp");

  const [code, setCode] = useState("");
  const [verifying, setVerifying] = useState(false);

  const handleVerify = async (e) => {
    e.preventDefault();
    if (code.length !== 6) {
      toast.error("Veuillez entrer un code à 6 chiffres");
      return;
    }
    setVerifying(true);
    try {
      const res = await axios.post(`${API}/auth/2fa/verify`, {
        temp_token: tempToken,
        code,
      });
      if (res.data.session_token) {
        localStorage.setItem("session_token", res.data.session_token);
      }
      setUser(res.data);
      toast.success("Connexion réussie !");
      navigate("/therapist");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Code invalide");
      setCode("");
    } finally {
      setVerifying(false);
    }
  };

  if (!tempToken) {
    navigate("/login");
    return null;
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4" data-testid="2fa-verify-page">
      <Card className="w-full max-w-sm">
        <CardHeader className="text-center">
          <div className="mx-auto w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center mb-3">
            <ShieldCheck className="w-7 h-7 text-primary" />
          </div>
          <CardTitle className="font-heading text-2xl">
            Vérification 2FA
          </CardTitle>
          <CardDescription>
            Entrez le code à 6 chiffres de votre application d'authentification
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleVerify} className="space-y-4">
            <Input
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={6}
              placeholder="000000"
              value={code}
              onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))}
              className="text-center text-2xl tracking-[0.5em] font-mono"
              autoFocus
              data-testid="2fa-verify-code-input"
            />
            <Button
              type="submit"
              className="w-full"
              disabled={verifying || code.length !== 6}
              data-testid="2fa-verify-btn"
            >
              {verifying ? (
                <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Vérification...</>
              ) : (
                "Vérifier"
              )}
            </Button>
            <p className="text-xs text-muted-foreground text-center">
              Ouvrez Google Authenticator ou Authy pour obtenir votre code
            </p>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default TwoFactorVerifyPage;
